import { render, staticRenderFns } from "./generatechart.vue?vue&type=template&id=37c90884"
import script from "./generatechart.vue?vue&type=script&lang=js"
export * from "./generatechart.vue?vue&type=script&lang=js"
import style0 from "./generatechart.vue?vue&type=style&index=0&id=37c90884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports